import React, { useState, useEffect } from 'react';
import axios from 'axios';
import getAPI from "../../service/getAPI";
import { Form, Row, Col } from 'react-bootstrap';

function AddNew({ onClose, editData }) {
    const { master } = getAPI();

    const [formValues, setFormValues] = useState({
        store_name: '',
        dial_code: '+91',
        mobile_no: '',
        password: '',
        address: '',
        lat: '',
        lng: '',
        area: '',
        city: '',
        state: '',
        country: 'India',
        pincode: '',
        is_active: true,
        user_type: 'store',
    });

    useEffect(() => {
        if (editData) {
            setFormValues({
                store_name: editData.store_name || '',
                dial_code: editData.dial_code || '+91',
                mobile_no: editData.mobile_no || '',
                password: editData.password || '',
                address: editData.address || '',
                lat: editData.lat || '',
                lng: editData.lng || '',
                area: editData.area || '',
                city: editData.city || '',
                state: editData.state || '',
                country: editData.country || 'India',
                pincode: editData.pincode || '',
                is_active: editData.is_active === 1,
                user_type: 'store',
            });
        }
    }, [editData]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormValues((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...formValues,
            is_active: formValues.is_active ? 1 : 0,
        };

        try {
            if (editData?.store_id) {
                await axios.post(master.storeEdit, {
                    ...payload,
                    store_id: editData.store_id,
                });
            } else {
                await axios.post(master.storeAdd, payload);
            }
            onClose();
        } catch (error) {
            console.error("Store Submit Error:", error);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <span className="modal-title">{editData ? 'Update Store' : 'Add New Store'}</span>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <Row className="mb-2">
                            <Col md={6}>
                                <div className="form-group">
                                    <label>Store Name <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        name="store_name"
                                        value={formValues.store_name}
                                        onChange={handleInputChange}
                                        required
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="form-group">
                                    <label>Mobile No. <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        name="mobile_no"
                                        value={formValues.mobile_no}
                                        onChange={handleInputChange}
                                        required
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-2">
                            <Col md={6}>
                                <div className="form-group">
                                    <label>Password <span className="text-danger">*</span></label>
                                    <input
                                        type="password"
                                        name="password"
                                        value={formValues.password}
                                        onChange={handleInputChange}
                                        required
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="form-group">
                                    <label>Address</label>
                                    <input
                                        type="text"
                                        name="address"
                                        value={formValues.address}
                                        onChange={handleInputChange}
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-2">
                            <Col md={6}>
                                <div className="form-group">
                                    <label>Area</label>
                                    <input
                                        type="text"
                                        name="area"
                                        value={formValues.area}
                                        onChange={handleInputChange}
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="form-group">
                                    <label>City</label>
                                    <input
                                        type="text"
                                        name="city"
                                        value={formValues.city}
                                        onChange={handleInputChange}
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-2">
                            <Col md={6}>
                                <div className="form-group">
                                    <label>State</label>
                                    <input
                                        type="text"
                                        name="state"
                                        value={formValues.state}
                                        onChange={handleInputChange}
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="form-group">
                                    <label>Country</label>
                                    <input
                                        type="text"
                                        name="country"
                                        value={formValues.country}
                                        disabled
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row className="mb-2">
                            <Col md={6}>
                                <div className="form-group">
                                    <label>Pincode</label>
                                    <input
                                        type="text"
                                        name="pincode"
                                        value={formValues.pincode}
                                        onChange={handleInputChange}
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className="form-group">
                                    <label>Latitude</label>
                                    <input
                                        type="text"
                                        name="lat"
                                        value={formValues.lat}
                                        onChange={handleInputChange}
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className="form-group">
                                    <label>Longitude</label>
                                    <input
                                        type="text"
                                        name="lng"
                                        value={formValues.lng}
                                        onChange={handleInputChange}
                                        className="form-control"
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <Form.Check
                                    type="switch"
                                    id="isActiveSwitch"
                                    name="is_active"
                                    label="Is Active?"
                                    checked={formValues.is_active}
                                    onChange={handleInputChange}
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddNew;
